export default __webpack_public_path__ + "static/media/ketoworkout_breakfast@3x.b0b2aaf1.jpg";